export default "__VITE_ASSET__b7200e0a__"